import Vue from "vue";
import { getLocale } from "@/data/regionInfo";

export default Vue.extend({
  data() {
		return {
			imageUrl: "",
			showSpinner: true
		};
	},
	computed: {
		pdm() {
			return this.$store.state.utils.pdm;
		},
		translations() {
			return this.$store.state.translations.data;
		},
		isDesignTransferApplied() {
			return this.$store.state.utils.isDesignTransferApplied;
		},
		enableStartOverModal() {
			return this.$store.state.utils.configuration.enableNewStartOverModal;
		},
		enableSnapshotService() {
			return this.$store.state.utils.configuration.enableSnapshotService;
		}
	},
	methods: {
		hideSpinner(hide: any): void {
			this.showSpinner = !hide;
		},

		getProductImage({ recipe_id }:{ recipe_id: number | string }) {
			const { pdm } = this.$store.state.utils;
			const featuredView = pdm?.product_images
				&& typeof pdm.product_images.featured_views.start_over !== "undefined"
				? pdm.product_images.featured_views.start_over
				: { view: "right_transparent", size: "md" };

			const productImages = this.$store.state.modals.productImages.startOver;
			if (productImages[recipe_id]) {
				this.imageUrl = productImages[recipe_id];
				this.hideSpinner(true);
				return;
			}

			this.$store
				.dispatch("ugc/tempData/GET_PRODUCT_IMAGES_BY_RECIPE_ID", {
					recipe_id,
					locale: getLocale(),
					type: 'customizer',
					...featuredView
				})
				.then(data => {
					const productImage = data[`${featuredView.view}_view`][featuredView.size];
					this.$store.commit('modals/SET_START_OVER_PRODUCT_IMAGE', {
						recipeId: recipe_id,
						data: productImage
					});
					this.imageUrl = productImage;
				});
		},

		ctaPrimaryAction(): void {
			const { initRecipe, defaultRecipe } = this.$store.state.recipe;
			let url = window.location.href;
			if(initRecipe.recipe_id !== defaultRecipe.recipe_id && !url.includes("recipe")) {
				url = url.includes("?") ? `${url}&recipe=${initRecipe.recipe_id}`
					: `${url}?recipe=${initRecipe.recipe_id}`;
			}

			this.$store.getters['utils/vsfActive'] && this.$eventBus.$emit('customsStartOver');

			if (this.$store.getters["utils/canvasActive"]) {
				window.parent.location = url as (string | Location) & Location;
			} else {
				window.location = url as (string | Location) & Location;
			}

		},

		ctaSecondaryAction(): void {
			if (this.$listeners && this.$listeners['cta-secondary-action']) {
				this.$emit('cta-secondary-action');
			} else {
				this.$modal.hide('startOverModal');
			}
		},

		closeAction(): void {
			this.imageUrl = '';
			this.showSpinner = true;
			this.$modal.hide('startOverModal');
		},

		beforeOpenModal(): void {
			const { initRecipe, defaultRecipe } = this.$store.state.recipe;
			const useInitRecipe = this.$store.state.utils.queryParams.recipe || this.isDesignTransferApplied;
			this.getProductImage({ recipe_id: ( useInitRecipe ? initRecipe.recipe_id : defaultRecipe.recipe_id)});
		}
	}
});